import { SearchForm } from "./SearchForm";
import { searchSuggest } from "../suggest";
import { ELEMENT_EVENT } from "../types/constants";
import { CLASSNAME, DATA, REPTILE, REPTILE_DATA } from "../types/element/constants";

const isAlreadyInitialized = false;
let searchForm: SearchForm;

export function focusHeaderSearchField() {
  if (Boolean(searchForm).valueOf()) {
    searchForm.focusSearchField();
  }
}

export function init() {
  let meta: Element | null;
  let headerForm: HTMLCollectionOf<HTMLFormElement>;
  const searchContainer: HTMLDivElement = document.getElementsByClassName(
    CLASSNAME.SEARCH_CONTAINER_CLASS,
  )[0] as HTMLDivElement;

  if (!isAlreadyInitialized && !!searchContainer) {
    headerForm = searchContainer.getElementsByClassName(
      CLASSNAME.SEARCH_FORM_CLASS,
    ) as HTMLCollectionOf<HTMLFormElement>;
    if (headerForm.length > 0) {
      searchForm = new SearchForm(headerForm[0], () => {
        window.o_global.eventLoader.onAllJavascriptLoaded(2, () => {
          let searchResult: HTMLDivElement = document.getElementById(REPTILE.SEARCH_RESULT_ID) as HTMLDivElement;

          if (!searchResult) {
            const searchResults = document.getElementsByClassName(REPTILE.SEARCH_RESULT_CLASS);
            if (searchResults.length > 0) {
              searchResult = searchResults[0] as HTMLDivElement;
            }
          }

          const query = (!!searchResult && searchResult.getAttribute(REPTILE_DATA.SEARCH_RESULT_QUERY)) || "";
          if (query !== "") {
            if (searchForm.isEmpty()) {
              searchForm.setValue(query);
              searchForm.setSearchFieldAttribute(DATA.SUGGEST_SEARCH_TERM, query);
              searchForm.toggleButtonVisibility();
            }
          }

          if (Boolean(searchSuggest).valueOf()) {
            window.o_squirrel.suggestLayer.init();
          }
        });
      });

      const searchField: HTMLInputElement = searchForm.getSearchField();

      if (searchField) {
        const _setMetaAttributes = (evt: Event) => {
          meta = document.querySelector('meta[name="viewport"]');
          meta &&
            meta.setAttribute(
              "content",
              "width=device-width, initial-scale=1" + (evt.type === "blur" ? "" : ",maximum-scale=1"),
            );
        };

        searchField.addEventListener(ELEMENT_EVENT.FOCUS, _setMetaAttributes);
        searchField.addEventListener(ELEMENT_EVENT.BLUR, _setMetaAttributes);
      }
    }
  }

  /*                                      */
  window.o_global.eventLoader.onReady(2, () => {
    const errorSearch: HTMLCollectionOf<Element> = document.getElementsByClassName(
      REPTILE.SEARCH_RESULT_ERROR_NO_RESULTS_CLASS,
    );
    if (errorSearch.length > 0) {
      const searchForm: HTMLFormElement = errorSearch[0].getElementsByClassName(
        CLASSNAME.SEARCH_FORM_CLASS,
      )[0] as HTMLFormElement;
      new SearchForm(searchForm);
    }
  });
}

export interface SearchHandler {
  init: () => void;
  focusHeaderSearchField: () => void;
}

export const searchHandler = { init, focusHeaderSearchField };
